import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import InstaragramIcon from "../../images/Svg/Instragram.svg";
import TwitterIcon from "../../images/Svg/dashboard/Twitter.svg";
import FacebookIcon from "../../images/Svg/dashboard/Facebook.svg";
import DeSocialWorldIcon from "../../images/Svg/checkProfle/DeSocialWorld.svg";

const FooterLayout = ({ show }) => {
  return (
    <>
      <div className={`${show ? "hidden md:inline" : ""}`}>
        <ul className="space-y-4">
          {LinkData.map((item, index) => (
            <li
              key={index}
              className="ease-in duration-30 cursor-pointer tracking-wider text-[#161616] flex items-center group md:mx-auto md:text-center "
            >
              <a href={item?.link}>{item.name}</a>
            </li>
          ))}
        </ul>
      </div>
      <div className={`${show ? "hidden md:inline" : ""}`}>
        <ul className="space-y-4">
          {ourInfo.map((item, index) => (
            <li
              key={index}
              className="cursor-pointer text-[#161616] tracking-wider group"
            >
              <a href={item?.link}>{item.name}</a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

const ourInfo = [
  {
    name: "Privacy Policy",
    link: "",
  },
  {
    name: "Terms of Use",
    link: "",
  },
];

const LinkData = [
  {
    id: 1,
    name: "About Setu",
    link: "/about",
  },
  {
    id: 2,
    name: "Our Team",
    link: "/our_team",
  },
  {
    name: "Blogs",
    link: "/blogs",
  },
  {
    name: "FAQs",
    link: "/faqs",
  },
];

const followData = [
  {
    id: 1,
    icon: DeSocialWorldIcon,
    link: "https://desocialworld.com/u/setu_deso?feedTab=feed.tab.tag&tab=posts",
  },
  {
    id: 2,
    icon: TwitterIcon,
    link: "https://twitter.com/Setuforcreators",
  },
  {
    id: 3,
    icon: InstaragramIcon,
    link: "https://www.instagram.com/setuforcreators/",
  },
  {
    id: 4,
    icon: FacebookIcon,
    link: "https://www.facebook.com/setuforcreators/",
  },
];

const pn = window.location.pathname;

const Footer = () => {
  return (
    <section
      className={`${
        pn === "/past_all_contents" ? "lg:mt-24" : ""
      } bg-[#F6F2FF] `}
    >
      <div className="container px-4 space-y-5 py-[24px] md:py-12 text-[#161616] mx-auto text-justify">
        <div className="md:grid grid-cols-1 md:grid-cols-4 gap-4 md:mx-auto">
          <ul>
            <li className=" flex items-center justify-center sm:justify-center lg:justify-start">
              <a href="/">
                <img
                  className="h-[32px] md:h-[48px]"
                  src={"https://i.ibb.co/njXDzfC/logo-1.png"}
                  alt="logo"
                />
              </a>
              {/* <p>Setu</p> */}
            </li>
            <li className="hidden sm:hidden md:inline">
              <h6 className="text-[#161616] -tracking-tight text-sm mt-4">
                All Copyright Reserved
              </h6>
            </li>
          </ul>
          <div className="md:hidden border border-[#B9B9B9] my-[16px] md:my-0"></div>
          <div className="grid grid-cols-2 md:hidden">
            <FooterLayout />
          </div>
          <FooterLayout show={true} />
          <div className="lg:[288px] md:mx-auto grid grid-cols-2 md:inline mt-[32px] sm:mt-[0px]">
            <div>
              <p className="text-[14px] text-[#161616]">Contact & Feedback</p>
              <div className="flex md:justify-start items-center mb-[23px] mt-4">
                <a
                  href="mailto:support@web3setu.com"
                  className="cursor-pointer mr-4"
                >
                  <img
                    className="w-[32px] h-[32px] md:w-[40px] md:h-[40px]"
                    src={"https://i.ibb.co/w4N6YXq/image-79.png"}
                    alt="icon"
                  />
                </a>
                <a
                  href={"https://discord.gg/M9njr5cBBT"}
                  target="_blank"
                  className="cursor-pointer"
                >
                  <img
                    className="w-[32px] h-[32px] md:w-[40px] md:h-[40px]"
                    src="https://i.ibb.co/c3KdPxs/Discord-png.png"
                  />
                </a>
              </div>
            </div>
            <div>
              <h1 className="text-[#161616] text-[14px] md:mt-[16px]">
                Follow us on
              </h1>
              <div className="flex justify-center md:justify-start items-center mb-[32px] md:mb-[0] mt-4">
                {followData.map((item, index) => (
                  <a
                    key={index}
                    href={item?.link}
                    target="_blank"
                    rel="noreferrer"
                    className="cursor-pointer  mr-4"
                  >
                    <img
                      className="w-[32px] h-[32px] md:w-[40px] md:h-[40px]"
                      src={item?.icon}
                      alt="icon"
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <h6 className=" text-[#161616S] text-[16px] text-center md:hidden pb-[32px]">
          All Copyright Reserved
        </h6>
      </div>
    </section>
  );
};

export default Footer;
